var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00619 6.69755L9.28514 2.10807C9.35148 1.97525 9.4535 1.86354 9.57978 1.78546C9.70605 1.70737 9.85159 1.66602 10.0001 1.66602C10.1485 1.66602 10.294 1.70737 10.4203 1.78546C10.5466 1.86354 10.6486 1.97525 10.715 2.10807L12.9939 6.69755L18.0887 7.4379C18.2356 7.45828 18.3739 7.51956 18.4877 7.61475C18.6015 7.70995 18.6862 7.83521 18.7322 7.97626C18.7782 8.1173 18.7836 8.26844 18.7479 8.41242C18.7121 8.5564 18.6366 8.68743 18.5299 8.79054L14.8439 12.3607L15.7141 17.4046C15.8255 18.052 15.1413 18.5449 14.5562 18.2397L10.0001 15.8572L5.44303 18.2397C4.85881 18.5458 4.1746 18.052 4.28601 17.4037L5.15618 12.3598L1.47021 8.78966C1.36406 8.68648 1.28898 8.55559 1.25351 8.41186C1.21805 8.26814 1.22361 8.11735 1.26957 7.97663C1.31553 7.83591 1.40005 7.7109 1.51352 7.61583C1.62699 7.52075 1.76485 7.45941 1.91144 7.43878L7.00619 6.69755Z",
    stroke: "#A7B3C0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.160aa5c44c97fd206493f7bf63ddc5ec.svg";
export { ForwardRef as ReactComponent };